import { PagoDto } from "./pagoDto.model";

export class CreatePagoRequest {
  pagos!: PagoDto[]
  idComprobante!: number | null
  idUsuario!: number | null
}
